import clsx from 'clsx'
import { useState } from 'react'

import type { InputPasswordProps } from './type'

import { VisibilityFilledIcon } from '@/components/icons/VisibilityFilled'
import { VisibilityOffFilledIcon } from '@/components/icons/VisibilityOffFilled'
import { Icon, InputText } from '@/components/ui'

export const InputPassword = (props: InputPasswordProps) => {
  const [isMasked, setIsMasked] = useState(true)

  return (
    <span className={clsx('tw-relative')}>
      <InputText type={isMasked ? 'password' : 'text'} {...props} />
      <button
        type="button"
        onClick={() => setIsMasked(!isMasked)}
        className={clsx(
          'tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2',
          'tw-transition tw-duration-stateChange hover:tw-opacity-hover'
        )}
      >
        {isMasked ? (
          <Icon icon={VisibilityFilledIcon} size={'xl'} />
        ) : (
          <Icon icon={VisibilityOffFilledIcon} size={'xl'} />
        )}
      </button>
    </span>
  )
}
